module.exports = __webpack_public_path__ + "static/media/8-item-c.2bf19647.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/8-item-c.jpg
// module id = 1213
// module chunks = 33